import React, { useEffect, useState } from 'react';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Lightbox from 'react-image-lightbox';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import Button from '@mui/material/Button';
// import p1 from 'assests/Photos/Kinder/k-1.jpg';

// import p2 from 'assests/Photos/achivements/raisingstar2022/c.jpg';
// import p3 from 'assests/Photos/achivements/raisingstar2022/21.jpg';
// import p4 from 'assests/Photos/achivements/raisingstar2022/31.jpg';
// import p5 from 'assests/Photos/achivements/raisingstar2022/c.jpg';
// import p6 from 'assests/Photos/achivements/raisingstar2022/drawing_3rd_prize_bronze_medal.jpeg';
// import p7 from 'assests/Photos/achivements/raisingstar2022/drawing_best_effort_medal.jpeg';
// import p8 from 'assests/Photos/achivements/raisingstar2022/drawing_medal.jpeg';
// import p9 from 'assests/Photos/achivements/raisingstar2022/handwriting_shield.jpeg';
// import p10 from 'assests/Photos/achivements/raisingstar2022/drawing_3rd_prize_bronze_medal.jpeg';
// import p11 from 'assests/Photos/achivements/raisingstar2022/drawing_best_effort_medal.jpeg';
// import p12 from 'assests/Photos/achivements/raisingstar2022/drawing_medal.jpeg';
// import p13 from 'assests/Photos/achivements/raisingstar2022/handwriting_shield.jpeg';

const Last = () => {

  const [config, setConfig] = useState({ base_image_url: '' });
  useEffect(() => {
    fetch('/config.json')
      .then(response => response.json())
      .then(data => setConfig(data))
      .catch(error => console.error('Error fetching config:', error));
  }, []);

  const p2 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/c.webp`;
  const p3 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/21.webp`;
  const p4 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/31.webp`;
  const p5 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/c.webp`;
  const p6 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_3rd_prize_bronze_medal.webp`;
  const p7 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_best_effort_medal.webp`;
  const p8 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_medal.webp`;
  const p9 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/handwriting_shield.webp`;
  const p10 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_3rd_prize_bronze_medal.webp`;
  const p11 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_best_effort_medal.webp`;
  const p12 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/drawing_medal.webp`;
  const p13 = `${config.base_image_url}/home/home-static/static-images/all-static-images/raisingstar2022/handwriting_shield.webp`;
  

  const theme = useTheme();
  const [currentImage, setCurrentImage] = useState(0);
  const [viewerIsOpen, setViewerIsOpen] = useState(false);

  const openLightbox = (index) => {
    setCurrentImage(index);
    setViewerIsOpen(true);
  };

  const closeLightbox = () => {
    setCurrentImage(0);
    setViewerIsOpen(false);
  };

  const isMd = useMediaQuery(theme.breakpoints.up('md'), {
    defaultMatches: true,
  });

  const photos = [

    {
      src: p2,
      source: p2,
      rows: 1,
      cols: 1,
    },
    {
      src: p3,
      source: p3,
      rows: 1,
      cols: 1,
    },
    {
      src: p4,
      source: p4,
      rows: 1,
      cols: 1,
    },
    {
      src: p5,
      source: p5,
      rows: 1,
      cols: 1,
    },
    {
      src: p6,
      source: p6,
      rows: 1,
      cols: 1,
    },
    {
      src: p7,
      source: p7,
      rows: 1,
      cols: 1,
    },
    {
      src: p8,
      source: p8,
      rows: 1,
      cols: 1,
    },
    {
      src: p9,
      source: p9,
      rows: 1,
      cols: 1,
    },
    {
      src: p10,
      source: p10,
      rows: 1,
      cols: 1,
    },
    {
      src: p11,
      source: p11,
      rows: 1,
      cols: 1,
    },
    {
      src: p12,
      source: p12,
      rows: 1,
      cols: 1,
    },
    {
      src: p13,
      source: p13,
      rows: 1,
      cols: 1,
    },

    // {
    //   src: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   source: 'https://assets.maccarianagency.com/backgrounds/img21.jpg',
    //   rows: 1,
    //   cols: 1,
    // },
  ];

  return (
    <Box>
      <Box display={'flex'} justifyContent={'flex-end'} marginBottom={2}>
        {/* <Button
          color="primary"
          size="large"
          endIcon={
            <svg
              width={16}
              height={16}
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M17 8l4 4m0 0l-4 4m4-4H3"
              />
            </svg>
          }
          onClick={() => openLightbox(0)}
        >
          Open the gallery
        </Button> */}
      </Box>
      <Box>
        <ImageList
          variant="quilted"
          cols={3}
          rowHeight={isMd ? 300 : 200}
          gap={isMd ? 16 : 4}
        >
          {photos.map((item, i) => (
            <ImageListItem key={i} cols={item.cols} rows={item.rows}>
              <LazyLoadImage
                height={'100%'}
                width={'100%'}
                src={item.src}
                alt="..."
                effect="blur"
                onClick={() => openLightbox(i)}
                style={{
                  objectFit: 'cover',
                  filter:
                    theme.palette.mode === 'dark' ? 'brightness(0.7)' : 'none',
                  cursor: 'poiner',
                  borderRadius: 8,
                }}
              />
            </ImageListItem>
          ))}
        </ImageList>
      </Box>
      {viewerIsOpen && (
        <Lightbox
          mainSrc={photos[currentImage].src}
          nextSrc={photos[(currentImage + 1) % photos.length].src}
          prevSrc={
            photos[(currentImage + photos.length - 1) % photos.length].src
          }
          onCloseRequest={() => closeLightbox()}
          onMovePrevRequest={() =>
            setCurrentImage((currentImage + photos.length - 1) % photos.length)
          }
          onMoveNextRequest={() =>
            setCurrentImage((currentImage + 1) % photos.length)
          }
          reactModalStyle={{ overlay: { zIndex: 1500 } }}
        />
      )}
    </Box>
  );
};


export default Last;